import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Role, User } from '../../../../core/interfaces/user';
import { MessageService } from 'primeng/api';
import { AccountApiService } from '../../../../core/services/account-api.service';
import { OrganizationApiService } from '../../../../core/services/organization-api.service';
import { SelectInput } from '../../../../shared/interfaces/select-input';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InputTextComponent } from '../../../../shared/components/input-text/input-text.component';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableComponent } from "../../../../shared/components/table/table.component";

@Component({
  selector: 'app-user-details',
  imports: [TableModule,
    DialogModule,
    InputTextComponent,
    ToastModule,
    MultiSelectModule,
    ReactiveFormsModule,
    TableComponent],
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss'
})
export class UserDetailsComponent {
  @Input() visible!: boolean;
  accountOptions: SelectInput[] = [];
  @Output() closeDialog = new EventEmitter();
  organizationOptions: SelectInput[] = [];

  _user!: User
  @Input() 
  set user(value: User) {
    this._user = value;
    if(value) {
      this._user = value;
      this.userForm.patchValue(this.user);
      this.userForm.controls.accountName.setValue(value.account?.name!)
      this.userForm.controls.organizationName.setValue(value.userOrganization?.organizationName!)
      this.userForm.controls.organizationTitle.setValue(value.userOrganization?.title!)      
    }

  }

  get user() {
    return this._user;
  }


  roles = [  {label: 'User', code: 'ROLE_USER'},
             {label: 'Admin', code: 'ROLE_ADMIN'}]
  statusOptions = [  {label: 'Yes', code: true},
             {label: 'No', code: false}]
  tableColumns = [{header: "Role", field: "role"},
                  {header: "Election Name", field: "campaignName"},
                 ];


  userForm = new FormGroup({
                   username: new FormControl({disabled: true, value: ''}, Validators.required),
                   id: new FormControl({disabled: true, value: ''}, Validators.required,),
                   email: new FormControl({disabled: true, value: ''}, [Validators.required, Validators.email]),
                   organizationName: new FormControl({disabled: true, value: ''}, Validators.required),
                   organizationTitle: new FormControl({disabled: true, value: ''}, Validators.required),
                   accountName: new FormControl({disabled: true, value: ''}, Validators.required,),
                   roles: new FormControl<Role[]>({disabled: true, value: []}, Validators.required,),
                   active: new FormControl<boolean | undefined>({disabled: true, value: false}, Validators.required,),
   });

  constructor(private messageService: MessageService, 
    private accountApi: AccountApiService, private organizationApi: OrganizationApiService) {
    this.loadOrganizations();
    this.loadAccounts();
  }


  loadAccounts() {

    this.accountApi.getAccounts().subscribe({
        next: (data) => {
          for(let item of data) {
            this.accountOptions.push({label: item.name, code: item.id})         
          }
        }   
      })
    
  }
  close() {
      this.closeDialog.emit("")
  }

  loadOrganizations() {

      this.organizationApi.getOrganization().subscribe({
        next: (data) => {
          for(let item of data) {
            this.organizationOptions.push({label: item.name, code: item.id})         
          }
        }, error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to load the accounts.", life: 5000 })
        }
        
      })
  
  }
}
